import { useQuery } from "@tanstack/react-query";
import { __AllQualifiedUSers } from "request/configuration/__QualifiedUsers";

// Hook para obtener todos los usuarios calificados sin paginación
export const useAllQualifiedUsers = (token, enabled = true) => {
  return useQuery({
    queryKey: ["allQualifiedUsers"],
    queryFn: async () => {
      const res = await __AllQualifiedUSers(token);
      
      if (res.data.status?.code === 403) {
        throw new Error(res?.data?.status?.message);
      }
      
      // Mapear los datos al formato esperado
      return res?.data?.status?.data?.map((item) => ({
        value: item.id,
        label: item.name_qualified,
      })) || [];
    },
    enabled: enabled && !!token,
    staleTime: 5 * 60 * 1000, // 5 minutos (usuarios calificados cambian menos frecuentemente)
    gcTime: 5 * 60 * 1000, // 5 minutos
    refetchOnWindowFocus: false,
    retry: 2,
    retryDelay: 1000
  });
};
